import { InsertDriveFileOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import shadows from '@mui/material/styles/shadows';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { darkerBackground, darkGrey, darkRed, primaryBlue } from '../models/colors';
import type { ITableHeaderFields } from '../pages/homepage';
import { useTSPProviders } from '../services';
import type { IIncompleteAggrement } from '../types';

const TableContainer = styled('div')`
	overflow-x: auto;
	box-shadow: ${shadows[1]};
`;

const Table = styled('table')`
	width: 100%;
	min-width: 720px;
	border-spacing: 0;
	flex-direction: column;
	border-collapse: collapse;
`;
const TableBody = styled('tbody')``;
const TableRowBase = styled('tr')`
	width: 100%;
	height: 48px;
	justify-content: space-between;
	& > * {
		padding: 6px;
	}
`;
const TableRowHeader = styled(TableRowBase as any)`
	background-color: ${primaryBlue};
`;
const TableRow = styled(TableRowBase as any)`
	&:nth-child(odd) {
		background-color: ${darkerBackground};
	}
`;
const TableHeader = styled('th')`
	color: #ffffff;
	text-align: left;
	font-weight: bold;
	&:first-child {
		padding-left: 10px;
	}
	&:last-child {
		text-align: right;
		padding-right: 10px;
	}
`;
const TableCell = styled('td')`
	&:last-child {
		text-align: right;
		font-weight: bold;
		padding-right: 10px;
		font-size: 0.875rem;
	}
	&[data-tag='expiration-date'] {
		display: flex;
		flex-direction: column;
	}
	&[data-tag='expiration-date'] > span {
		width: 100%;
	}
	&[data-tag='active'] {
		color: ${primaryBlue};
	}
	&[data-tag='signed'] {
		color: ${darkGrey};
	}
	&[data-tag='expired'] {
		color: ${darkRed};
	}
`;
const ViewAgreement = styled(({ label, onClick, ...rest }: any) => (
	<Button
		variant={`text`}
		sx={{
			padding: '4px',
			fontWeight: 'bold',
			fontSize: '0.8125rem',
			textTransform: 'none',
			color: primaryBlue,
		}}
		{...rest}
		onClick={onClick}
	>
		<InsertDriveFileOutlined />
		{label}
	</Button>
))`
	&:hover {
		text-decoration: underline;
	}
`;

export const InProgressAgreementsTable = ({ data, headers }: any) => {
	const navigate = useNavigate();
	const { tspProviders } = useTSPProviders();

	return (
		<>
			{tspProviders.isComplete ? (
				<TableContainer>
					<Table>
						<TableBody>
							<TableRowHeader>
								{headers.map((v: ITableHeaderFields, idx: number) => (
									<TableHeader title={v.title} key={idx}>
										{v.label}
									</TableHeader>
								))}
							</TableRowHeader>
							{data.map((v: IIncompleteAggrement, idx: number) => (
								<TableRow key={idx}>
									<TableCell>
										<ViewAgreement
											label="Finish filling out this agreement"
											onClick={() => navigate(`/agreement/update?id=${v.id}`)}
										/>
									</TableCell>
									<TableCell>
										{
											tspProviders.data.filter(
												(i: any) => i.id.toString() === v.tspId.toString()
											)[0].name
										}
									</TableCell>
									<TableCell>{v.name ? v.name : 'Unnamed company'}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
               null
			)}
		</>
	);
};
